import { render, staticRenderFns } from "./sessionImotAddRemove.vue?vue&type=template&id=57476dcc"
import script from "./sessionImotAddRemove.vue?vue&type=script&lang=js"
export * from "./sessionImotAddRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports